import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { AuditLogEvents } from "@ryde/shared";

export const useAuditLogEventName = () => {
  const { t } = useTranslation();

  const getEventName = useMemo(
    () => (eventName: AuditLogEvents) => {
      switch (eventName) {
        case AuditLogEvents.EntityCreated:
          return t("auditLog.events.created");
        case AuditLogEvents.EntityUpdated:
          return t("auditLog.events.updated");
        case AuditLogEvents.EntityDeleted:
          return t("auditLog.events.deleted");
        default:
          return eventName;
      }
    },
    [t],
  );

  return { getEventName };
};
